export function isFullTrialUnlockDisallowed(featureFlags?: Record<string, unknown>): boolean {
  return featureFlags?.DISALLOW_TO_USE_FULL_TRIAL_SUBSCRIPTION === true;
}
